// WHY: оптимизатор Next пропускает только хосты из images.remotePatterns в next.config.mjs — префикс должен совпадать
const OPTIMIZED_PREFIX = 'https://shot.band/images/';

// WHY: оптимизатор принимает только ширины из imageSizes и deviceSizes — берём стандартные, ближайшие к карточке ~190–210 px
// при плотности 1, 2 и 3; свои 192 и 512 потребовали бы расширить общий список и поменяли бы srcset картинок вики
const CASE_IMAGE_WIDTHS = [256, 384, 640];

const QUALITY = 75;

const optimizedUrl = (src: string, width: number): string =>
  `/_next/image?url=${encodeURIComponent(src)}&w=${width}&q=${QUALITY}`;

export const caseImageSrcSet = (src: string): string | undefined =>
  src.startsWith(OPTIMIZED_PREFIX)
    ? CASE_IMAGE_WIDTHS.map((width) => `${optimizedUrl(src, width)} ${width}w`).join(', ')
    : undefined;
